export const Permissions = {
	AccountManagement: 1,
	WorkshopSettings: 2,
	Payments: 44,
	AccessToDriveSettings: 42,
	HasRestrictedDossierAccess: 66,
	AccessToMessageTemplates: 69,
};